import { render } from "./TramiteCargaUtilidades.vue?vue&type=template&id=66bad8fe&scoped=true"
import script from "./TramiteCargaUtilidades.vue?vue&type=script&lang=js"
export * from "./TramiteCargaUtilidades.vue?vue&type=script&lang=js"

import "./TramiteCargaUtilidades.vue?vue&type=style&index=0&id=66bad8fe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bad8fe"]])

export default __exports__